import { render, staticRenderFns } from "./sharelink-popup.vue?vue&type=template&id=6fab6c82&"
import script from "./sharelink-popup.vue?vue&type=script&lang=js&"
export * from "./sharelink-popup.vue?vue&type=script&lang=js&"
import style0 from "./sharelink-popup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports